import { jsx as r, jsxs as p } from "@emotion/react/jsx-runtime";
import { Fragment as a } from "react";
import { useTheme as i } from "@emotion/react";
import { Stack as n, Separator as c } from "@partoohub/ui";
import { DynamicFramework as l } from "./DynamicFramework.js";
const x = ({
  schema: o
}) => {
  const m = i();
  return /* @__PURE__ */ r(n, { gap: "24px", children: o?.map((t, e) => /* @__PURE__ */ p(a, { children: [
    /* @__PURE__ */ r(l, { section: t }),
    o.length - 1 !== e && /* @__PURE__ */ r(c, { color: m.colors.default.alpha })
  ] }, t.property)) });
};
export {
  x as BuilderComponent
};
